import React from 'react';
import { Typography as AntTypography } from 'antd';

/**
 * Wrapper component for Ant Design Typography
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Typography functionality and sub-components.
 * 
 * @component
 * @example
 * import { Typography } from '../GeneralComponents/ui';
 * 
 * const { Text, Title, Paragraph } = Typography;
 * 
 * <Typography>
 *   <Title>h1. Ant Design</Title>
 *   <Title level={2}>h2. Ant Design</Title>
 *   <Title level={3}>h3. Ant Design</Title>
 *   <Title level={4}>h4. Ant Design</Title>
 *   <Paragraph>This is a paragraph.</Paragraph>
 *   <Text>This is text.</Text>
 * </Typography>
 * 
 * @see https://ant.design/components/typography/ - Ant Design Typography documentation
 */
const Typography = (props) => {
  return <AntTypography {...props} />;
};

// Preserve Typography sub-components
Typography.Text = AntTypography.Text;
Typography.Title = AntTypography.Title;
Typography.Paragraph = AntTypography.Paragraph;

export default Typography;

